const MtrKanbanViewOutline={
    "name": "mtr-kanban-view",
    "theme": "outline",
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
        },
        "children": [
            {},
            {
                "tag": "path",
                "attrs": {
                    "d": "M18 5V11",
                    "stroke": "currentColor",
                    "stroke-width": "2",
                    "stroke-miterlimit": "10",
                    "stroke-linecap": "round"
                }
            },
            {},
            {
                "tag": "path",
                "attrs": {
                    "d": "M12 5V15",
                    "stroke": "currentColor",
                    "stroke-width": "2",
                    "stroke-miterlimit": "10",
                    "stroke-linecap": "round"
                }
            },
            {},
            {
                "tag": "path",
                "attrs": {
                    "d": "M6 5L6 19",
                    "stroke": "currentColor",
                    "stroke-width": "2",
                    "stroke-miterlimit": "10",
                    "stroke-linecap": "round"
                }
            },
            {}
        ]
    }
};
export default MtrKanbanViewOutline;